module.exports = __webpack_public_path__ + "static/open-graph-image-74fba6a589f4e025091097c09432e098.png";